import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { AdminSidebarComponent } from '../../sidebar/admin-sidebar.component';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';
import { AdminUserActivitiesComponent } from '../user-activities.component';

@Component({
  selector: 'app-user-activities-home',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    AdminSidebarComponent,
    PageHeaderComponent,
    AdminUserActivitiesComponent
  ],
  templateUrl: './user-activities-home.component.html',
  styleUrl: './user-activities-home.component.scss',
})
export class UserActivitiesHomeComponent {}
